import reducer from './reducers';

export { default as summaryTemplatesSelectors } from './selectors';
export { default as summaryTemplatesOperations } from './operations';
export { default as summaryTemplatesTypes } from './types';

export default reducer;
